import './update.css';

export default function Update({ isUpdating }) {

    return (
        <div className='updatepage' style={{ display: isUpdating && window.location.pathname !== '/admin' ? 'flex' : 'none' }}>
            <div className="loading-circle"></div> {/* دایره در حال چرخش */}
            <h1>در حال آپدیت ...</h1>
            <p>آپدیت سیستم در حال انجام است. لطفاً چند دقیقه دیگر دوباره امتحان کنید.</p>
        </div>
    );
};